import { PayloadAction } from '@reduxjs/toolkit';
import { IKeywordAdmin } from '@/store/types.admin';
import { createSliceSteamup } from '../common';

interface IKeywordManageState {
  loading: boolean;
  list: IKeywordAdmin[];
  selectedGroup: string;
}

const keywordManageSlice = createSliceSteamup(
  'keywordManage',
  {
    loading: false,
    list: [],
    selectedGroup: '',
  } as IKeywordManageState,
  {
    updateKeywordName(state, { payload }: PayloadAction<{ id: number, newName: string }>) {
      const target = state.list.find((keyword) => keyword.id === payload.id);
      if (!target) return;
      target.name = payload.newName;
    },
    deleteKeyword(state, { payload }: PayloadAction<{ id: number }>) {
      const targetIndex = state.list.findIndex((keyword) => keyword.id === payload.id);
      if (targetIndex < 0) return;
      state.list.splice(targetIndex, 1);
    },
    clearZeroKeyword(state) {
      state.list = state.list.filter(({ id }) => id !== 0);
    },
    addGroup(state, { payload }: PayloadAction<string>) {
      state.list.push({ id: 0, group: payload, name: '' });
    },
    prepareAddNewKeyword(state) {
      state.list = state.list.filter(({ id }) => id !== 0);
      state.list.push({ id: 0, group: state.selectedGroup, name: '' });
    },
  },
);

export default keywordManageSlice;
